import React from 'react'

const EmailLink = ({
	email,
	ariaLabel,
}: {
	email: string
	ariaLabel: string
}) => (
	<a
		href={`mailto:${email}`}
		style={{ color: 'inherit', textDecoration: 'underline' }}
		aria-label={ariaLabel}>
		{email}
	</a>
)

export const createEmailComponents = (
	t: any,
	emailsKey: string,
	ariaLabelKey: string,
) => {
	const emails = t(emailsKey, { returnObjects: true }) || []
	const ariaLabel = t(ariaLabelKey)

	return Array.isArray(emails)
		? emails.map((email: string) => (
				<EmailLink key={email} email={email} ariaLabel={ariaLabel} />
			))
		: []
}
